export default ({ app }, inject) => {
  const currency = (value) => app.i18n.n(value, 'currency')
  inject('currency', currency)

  inject('conditionalSubcurrency', (value) => {
    const subcurrencyMap = {
      GBP: 'p',
      EUR: 'c',
    }
    const subcurrency = subcurrencyMap[app.i18n.localeProperties?.currencyCode]
    if (Math.abs(value) >= 1 || !subcurrency) {
      return currency(value)
    }

    return `${Math.round(value * 100)}${subcurrency}`
  })
}
